import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_LMEXPRESS_REQUEST,
  FETCH_LMEXPRESS_SUCCESS,
  FETCH_LMEXPRESS_ERROR,
  FETCH_LMEXPRESS_PARAMETERS_REQUEST,
  FETCH_LMEXPRESS_PARAMETERS_SUCCESS,
  FETCH_LMEXPRESS_PARAMETERS_ERROR,
  UPDATE_LMEXPRESS_PARAMETERS_REQUEST,
  UPDATE_LMEXPRESS_PARAMETERS_SUCCESS,
  UPDATE_LMEXPRESS_PARAMETERS_ERROR,
} from 'actionTypes'

/*
 * REQUEST LM EXPRESS DATA
 */
export const fetchLmExpress = (auth, filters) => (dispatch) => {
  dispatch(fetchLmExpressRequest())

  /* istanbul ignore else */
  if (!filters || !filters.idBranch) {
    filters = {
      ...filters,
      idBranch: auth.user.locationCode.padStart(4, '0'),
    }
  }

  const params = {
    ...filters,
  }

  return new Api(auth.user.dsToken, dispatch)
    .post(API_URL.LMEXPRESS, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchLmExpressSuccess(response.data, params))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchLmExpressError(error, params))
      dispatch(hideSpinner())
    })
}

export const fetchLmExpressRequest = () => ({
  type: FETCH_LMEXPRESS_REQUEST,
})

export const fetchLmExpressSuccess = (data, filters) => ({
  type: FETCH_LMEXPRESS_SUCCESS,
  payload: data,
  filters,
})

export const fetchLmExpressError = (error, filters) => ({
  type: FETCH_LMEXPRESS_ERROR,
  payload: error,
  filters,
})

/*
 * REQUEST LM EXPRESS PARAMETERS
 */
export const fetchLmExpressParameters = (auth) => (dispatch) => {
  dispatch(fetchLmExpressParametersRequest())

  const params = {}

  return new Api(auth.user.dsToken, dispatch)
    .get(API_URL.LMEXPRESS_PARAMETERS, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchLmExpressParametersSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchLmExpressParametersError(error))
      dispatch(hideSpinner())
    })
}

export const fetchLmExpressParametersRequest = () => ({
  type: FETCH_LMEXPRESS_PARAMETERS_REQUEST,
})

export const fetchLmExpressParametersSuccess = (data) => ({
  type: FETCH_LMEXPRESS_PARAMETERS_SUCCESS,
  payload: data,
})

export const fetchLmExpressParametersError = (error) => ({
  type: FETCH_LMEXPRESS_PARAMETERS_ERROR,
  payload: error,
})

/*
 * SAVE or UPDATE PARAMETERS
 */
export const updateLmExpressParameters =
  (auth, toSave = null) =>
  (dispatch) => {
    dispatch(updateLmExpressParametersRequest())

    return new Api(auth.user.dsToken, dispatch)
      .post(API_URL.LMEXPRESS_PARAMETERS, toSave)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(updateLmExpressParametersSuccess(response.data))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(updateLmExpressParametersError(error))
        dispatch(hideSpinner())
      })
  }

export const updateLmExpressParametersRequest = () => ({
  type: UPDATE_LMEXPRESS_PARAMETERS_REQUEST,
})

export const updateLmExpressParametersSuccess = (data) => ({
  type: UPDATE_LMEXPRESS_PARAMETERS_SUCCESS,
  payload: data,
})

export const updateLmExpressParametersError = (error) => ({
  type: UPDATE_LMEXPRESS_PARAMETERS_ERROR,
  payload: { error },
})
